import angular from "angular";
import { Knowledge } from "./knowledge/knowledge.component";
import { KnowledgeManager } from "./knowledge/knowledgeManager/knowledgeManager.component";
import { KnowledgeDocuments } from "./knowledge/knowledgeDocuments/knowledgeDocuments.component";
import { AiOutputs } from "./aiOutputs/aiOutputs.component";
import { AiOutputsEdit } from "./aiOutputs/aiOutputsEdit/aiOutputsEdit.component";
import { AnswerComponent } from "./instructions/answer/answer.component";
import { AgentInputsComponent } from "./instructions/inputs/inputs.component";
import { BuilderAiAgentService } from "../../../services/BuilderAiAgentService";
import TranslateService from "modules/translate/TranslateService";
import { CustomMcpComponent } from "./tools/mcp/CustomMcp.component";
import { instructionsTabModule } from "./instructions";
export const aiAgentTabsComponents = angular
    .module('aiAgentTabsComponents', [instructionsTabModule])
    .component('knowledgeTab', Knowledge)
    .component('knowledgeManager', KnowledgeManager)
    .component('knowledgeDocuments', KnowledgeDocuments)
    .component('aiOutputsTab', AiOutputs)
    .component('aiOutputsEdit', AiOutputsEdit)
    .component('answer', AnswerComponent)
    .component('agentInputs', AgentInputsComponent)
    .component('customMcp', CustomMcpComponent)
    .service('BuilderAiAgentService', BuilderAiAgentService)
    .service('translateService', TranslateService)
    .name;
